import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from '../Base';
import Letter from "../Secretariat/Letter";
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class Forms extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'form',
            data: null,
            loading: true,
            page: 1,
            per_page: 30,
            phrase: '',
            menuId: 106
        };
        this.setFilters(props);
    }
    componentWillReceiveProps(props) {
        this.setFilters(props);
    }
    setFilters(props) {
        this.state.filters = {
            status: 0,
            subType: 0,
            type: props.Type,
            letterFullNumber: ''
        }
    }
    getCaption() {
        if (this.state.filters.type === 1) return "درخواستهای اضافه کاری";
        if (this.state.filters.type === 2) return "درخواستهای ماموریت";
        if (this.state.filters.type === 3) return "درخواستهای مساعده حقوق";
        return '';
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({
            component: <Letter Caller={this} FormType={this.state.filters.type} Source={3} CallerSection={"form"} />,
        });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <Letter Caller={this} FormType={this.state.filters.type} Source={3} Id={id} CallerSection={"form"} />,
        });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست {this.getCaption()}</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} مورد یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}><em className="icon ni ni-plus"></em><span>ایجاد</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input placeholder="شماره درخواست" defaultValue={this.state.filters.letterFullNumber} onChange={e => this.state.filters.letterFullNumber = e.target.value} className="form-control" type="text" />
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.status} onChange={e => this.state.filters.status = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">همه وضعیتها</option>
                                                    <option value="1">در انتظار بررسی</option>
                                                    <option value="2">تایید شده</option>
                                                    <option value="3">رد شده</option>
                                                </select>
                                            </div>
                                            {this.state.filters.type === 2 && <div className="form-wrap">
                                                <select defaultValue={this.state.filters.subType} onChange={e => this.state.filters.subType = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">همه نوع</option>
                                                    <option value="1">درون شهری</option>
                                                    <option value="2">برون شهری</option>
                                                    <option value="3">فوق العاده</option>
                                                </select>
                                            </div>}
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ درخواستی یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره درخواست</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">وضعیت</span></div>

                                            {this.state.filters.type === 1 && <div className="nk-tb-col text-center"><span className="sub-text">از ساعت</span></div>}
                                            {this.state.filters.type === 1 && <div className="nk-tb-col text-center"><span className="sub-text">تا ساعت</span></div>}

                                            {this.state.filters.type === 2 && <div className="nk-tb-col text-center"><span className="sub-text">نوع</span></div>}
                                            {this.state.filters.type === 2 && <div className="nk-tb-col text-center"><span className="sub-text">از تاریخ</span></div>}
                                            {this.state.filters.type === 2 && <div className="nk-tb-col text-center"><span className="sub-text">تا تاریخ</span></div>}
                                            {this.state.filters.type === 2 && <div className="nk-tb-col text-center"><span className="sub-text">وسیله نقلیه</span></div>}
                                            {this.state.filters.type === 2 && <div className="nk-tb-col text-center"><span className="sub-text">پلاک</span></div>}
                                            {this.state.filters.type === 2 && <div className="nk-tb-col text-center"><span className="sub-text">مقصد</span></div>}

                                            {this.state.filters.type === 3 && <div className="nk-tb-col text-center"><span className="sub-text">مبلغ</span></div>}
                                            {this.state.filters.type === 3 && <div className="nk-tb-col text-center"><span className="sub-text">علت درخواست</span></div>}
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.letterFullNumber}</span>
                                                </div>
                                                <div className="nk-tb-col"><span className="sub-text text-center">{record.statusString}</span></div>

                                                {this.state.filters.type === 1 && <div className="nk-tb-col"><span className="sub-text text-center">{record.fromTime}</span></div>}
                                                {this.state.filters.type === 1 && <div className="nk-tb-col"><span className="sub-text text-center">{record.toTime}</span></div>}

                                                {this.state.filters.type === 2 && <div className="nk-tb-col"><span className="sub-text text-center">{record.subTypeString}</span></div>}
                                                {this.state.filters.type === 2 && <div className="nk-tb-col"><span className="sub-text text-center">{record.fromDateString}</span></div>}
                                                {this.state.filters.type === 2 && <div className="nk-tb-col"><span className="sub-text text-center">{record.toDateString}</span></div>}
                                                {this.state.filters.type === 2 && <div className="nk-tb-col"><span className="sub-text text-center">{record.car}</span></div>}
                                                {this.state.filters.type === 2 && <div className="nk-tb-col"><span className="sub-text text-center">{record.carNo}</span></div>}
                                                {this.state.filters.type === 2 && <div className="nk-tb-col"><span className="sub-text text-center">{record.address}</span></div>}

                                                {this.state.filters.type === 3 && <div className="nk-tb-col"><span className="sub-text text-center">{this.money(record.price)}</span></div>}
                                                {this.state.filters.type === 3 && <div className="nk-tb-col"><span className="sub-text text-center">{record.description}</span></div>}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}